import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appClickStopPropigation]'
})
export class ClickStopPropigationDirective {

  @HostListener("click", ["$event"])
    public onClick(event: any): void
    {
        event.stopPropagation();
    }

  constructor() { }

}
